const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    maxHeight: 36,
  },
});

export default styles;
